<template>
  <div :class="baseEventSectionClasses">
    <div class="szw-flex szw-items-center szw-justify-center szw-gap-[px] szw-h-[26px]">
      <span class="szw-font-bold szw-text-2xl szw-w-10 szw-text-center szw-tracking-wider">
        {{ props.homeScore }}
      </span>
      <span class="szw-font-regular szw-text-2xl">:</span>
      <span class="szw-font-bold szw-text-2xl szw-w-10 szw-text-center szw-tracking-wider">
        {{ props.awayScore }}
      </span>
    </div>

    <div v-show="props.matchStatus" class="szw-bg-white/10 szw-rounded-lg szw-h-[22px] szw-mt-[4px] szw-px-[8px] szw-text-xxs szw-leading-[23px] szw-tracking-wider szw-text-center">
       {{ props.matchStatus }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  homeScore: {
    type: Number,
    default: 0
  },
  awayScore: {
    type: Number,
    default: 0
  },
  matchStatus: {
    type: String,
    default: ''
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  }
})

const baseClasses = ['szw-flex szw-flex-col szw-items-center szw-p-1.5 szw-text-nowrap szw-justify-center']
const baseEventSectionClasses = computed(() => [...baseClasses, props.isSmallWidgetContainerSize ? 'szw-mx-2' : 'szw-mx-4'])
</script>
